import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
let default_1 = class extends Vue {
  get language() {
    return AppModule.language;
  }
  handleSetLanguage(lang) {
    this.$i18n.locale = lang;
    AppModule.SetLanguage(lang);
    this.$message({
      message: 'Switch Language Success',
      type: 'success'
    });
  }
};
default_1 = __decorate([Component({
  name: 'Login'
})], default_1);
export default default_1;